"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PER_DAY_INFO: "We will automatically calculate the price based on the number of days booked and the quantity selected here.",
    PER_GUEST_INFO: "We will automatically calculate the price based on the number of guests booked and the quantity selected here.",
    PER_GUEST_PER_DAY_INFO: "We will automatically calculate the price based on the number of guests and days booked and the quantity selected here. Most bookings will only need this quantity set to 1.",
    TOTAL: "Total",
    DUE_AFTER_TRIP: "Due after trip",
    DEPOSIT: "Deposit",
    DAY: "day",
    GUEST: "guest",
};
